var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.165,
    height: 16.873,
    viewBox: "0 0 23.165 16.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-electric-car-8036274",
    transform: "translate(-10.008 -20.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36876",
    "data-name": "Trac\\xE9 36876",
    d: "M23.245,68.02a1.611,1.611,0,1,0,0,3.222,1.653,1.653,0,0,0,1.161-.472,1.59,1.59,0,0,0,.484-1.138v0a1.628,1.628,0,0,0-1.645-1.609Z",
    transform: "translate(-8.234 -33.503)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36877",
    "data-name": "Trac\\xE9 36877",
    d: "M68.676,68.02a1.628,1.628,0,0,0-1.644,1.609v0a1.646,1.646,0,1,0,1.644-1.613Z",
    transform: "translate(-40.515 -33.503)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36878",
    "data-name": "Trac\\xE9 36878",
    d: "M40.883,53.646V51.661a11.254,11.254,0,0,0-5.113,2.151Z",
    transform: "translate(-18.304 -21.879)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36879",
    "data-name": "Trac\\xE9 36879",
    d: "M55.539,51.5v2.01l5.248-.171a8.171,8.171,0,0,0-5.02-1.844c-.078,0-.153,0-.228.006Z",
    transform: "translate(-32.35 -21.759)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36880",
    "data-name": "Trac\\xE9 36880",
    d: "M31.791,49.983l-1.375-.417a2.005,2.005,0,0,1-.5-.228c-4.276-2.665-9-2.573-14.024.278a2.536,2.536,0,0,1-.7.267l-2.745.57a3.04,3.04,0,0,0-2.44,2.947v.573a.72.72,0,0,0,.729.709h2.043a2.26,2.26,0,0,1,4.467,0h8.685a2.26,2.26,0,0,1,4.467,0h2.043a.722.722,0,0,0,.729-.709V51.816a1.929,1.929,0,0,0-1.382-1.833Zm-2.238.831a.311.311,0,0,1-.278.206l-12.761.414H16.5a.3.3,0,0,1-.188-.545A12.253,12.253,0,0,1,22.883,48h.007q.265-.017.529-.017a9.109,9.109,0,0,1,6.045,2.5.3.3,0,0,1,.089.33Z",
    transform: "translate(0 -18.856)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36881",
    "data-name": "Trac\\xE9 36881",
    d: "M47.533,27.224a.351.351,0,0,0,.148.041.3.3,0,0,0,.232-.11l3.266-3.827A.309.309,0,0,0,51.225,23a.3.3,0,0,0-.278-.176H49.893l.883-1.412a.3.3,0,0,0,.011-.3.3.3,0,0,0-.252-.165l-1.552-.081a.3.3,0,0,0-.275.139l-1.861,2.953a.306.306,0,0,0,.241.466l1.039.063-.738,2.379a.3.3,0,0,0,.144.356Z",
    transform: "translate(-26.141)",
    fill: "#cea95a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinks);
export default __webpack_public_path__ + "static/media/drinks.f4a4c82be05f8bddee553554f86f3290.svg";
export { ForwardRef as ReactComponent };